export const PHONE_DISPLAY = "027 294 3625";
export const PHONE_TEL = "+64272943625";
export const EMAIL = "info@virtualbookkeeping.co.nz";
export const BUSINESS_NAME = "Virtual Bookkeeping";
export const OWNER = "Annelize";
export const HOURLY_RATE = "$75";
